import React, { useState, useEffect } from "react";
import { useSite } from "./../../util/sites";
import DataDownload from "../general/DataDownload";

function ExtractContent() {
	const currentSite = useSite();
	const [selectedSite, setSelectedSite] = useState(null);

	useEffect(() => {
		if (currentSite.selectedSite != null)
			setSelectedSite(currentSite.selectedSite);
	}, [currentSite.selectedSite]);

	return (
		<div style={{ height: "88vh" }}>
			<div className="panel-heading main-color-bg">
				<h3 className="panel-title headerDownload">
					<span className="glyphicon glyphicon-cog" aria-hidden="true"></span>{" "}
					P10 Data Download
				</h3>
			</div>
			<DataDownload selectedSite={selectedSite} style={{ marginTop: "10%" }} />
		</div>
	);
}

export default ExtractContent;
